/* ============================================================
   BASICARE — お知らせバーのメッセージ回転

   カンプでは 3800ms 固定でしたが、管理画面から間隔を変更できるよう
   data-ann-rotate（秒）から読み取ります。

   テーマエディタでセクションが差し替わったときにタイマーが二重に
   走らないよう、要素ごとにタイマーIDを保持して張り替えます。
   ============================================================ */
(function () {
  var timers = new WeakMap();

  function stop(rot) {
    var id = timers.get(rot);
    if (id) {
      clearInterval(id);
      timers.delete(rot);
    }
  }

  function start(rot) {
    stop(rot);
    var msgs = rot.querySelectorAll('.ann-msg');
    if (msgs.length < 2) return; /* 1件のみなら回転不要 */

    var seconds = parseFloat(rot.getAttribute('data-ann-rotate')) || 4;
    var i = 0;
    var id = setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, seconds * 1000);
    timers.set(rot, id);
  }

  function init(root) {
    (root || document).querySelectorAll('.ann-rot').forEach(start);
  }

  init(document);

  /* テーマエディタでの差し替えに追従 */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('.ann-rot').forEach(stop);
    }
  });
})();
